import script from "./IncinerationNewEntery.vue?vue&type=script&setup=true&lang=js"
export * from "./IncinerationNewEntery.vue?vue&type=script&setup=true&lang=js"

import "./IncinerationNewEntery.vue?vue&type=style&index=0&id=028e2b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-028e2b82"]])

export default __exports__